import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Grid, IconButton, Stack, Tooltip } from "@mui/material";
import { DeleteStaffsAPI } from "api/staffs/staffs.api";
import { ConfirmDeleteModal } from "components/ConfirmDeleteModal";
import { Modal } from "components/Modal";
import { Table } from "components/Table";
import { handleError } from "functions/apiHandleError";
import { useEffect, useState } from "react";
import { CreateUpdateRoleModal } from "../createUpdateRoleModal";
import classes from "./style.module.scss";

export const StaffRolesModal = ({
  open,
  onClose,
  selectedStaff,
  reload,
  setReload,
  onRolesChanged,
}) => {
  const [rolesRows, setRolesRows] = useState([]);

  const [createUpdateModal, setCreateUpdateModal] = useState({
    open: false,
    selectedRole: null,
    selectedUser: null,
  });
  const [deleteModal, setDeleteModal] = useState({
    open: false,
    selectedRole: null,
  });
  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setRolesRows(selectedStaff?.roles ?? []);
    }
  }, [open, selectedStaff]);

  const handleCloseModal = () => {
    onClose();
  };

  const handleDeleteRole = async () => {
    const roleID = deleteModal.selectedRole?.id;
    if (!roleID) return;

    setDeleteLoading(true);

    try {
      await DeleteStaffsAPI(roleID);

      setRolesRows((prev) => prev.filter((item) => item.id !== roleID));

      await onRolesChanged?.();
      setDeleteModal({ open: false, selectedRole: null });
    } catch (err) {
      handleError({ err });
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleCloseCreateUpdateModal = () => {
    setCreateUpdateModal({
      open: false,
      selectedRole: null,
      selectedUser: null,
    });
  };

  const handleCreateUpdateSuccess = async (newRole) => {
    if (newRole?.id) {
      setRolesRows((prev) => {
        const roleExists = prev.some((item) => item.id === newRole.id);

        if (roleExists) {
          return prev.map((item) => (item.id === newRole.id ? newRole : item));
        }

        return [...prev, newRole];
      });
    }

    await onRolesChanged?.();

    handleCloseCreateUpdateModal();
  };
  const columns = [
    {
      field: "role_display",
      headerName: "سمت",
      minWidth: 110,
      flex: 1,
      sortable: false,
    },
    {
      field: "faculties_display",
      headerName: "دانشکده",
      minWidth: 130,
      flex: 1,
      sortable: false,
    },
    {
      field: "fields_display",
      headerName: "گروه",
      minWidth: 130,
      flex: 1,
      sortable: false,
    },
    {
      field: "action",
      headerName: "",
      minWidth: 90,
      flex: 1,
      sortable: false,
      renderCell: ({ row }) => (
        <Stack spacing={2} direction="row">
          <Tooltip title="ویرایش">
            <IconButton
              color="primary"
              onClick={() =>
                setCreateUpdateModal({
                  open: true,
                  selectedRole: row,
                  selectedUser: selectedStaff?.id,
                })
              }
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>

          <Tooltip title="حذف">
            <IconButton
              color="error"
              onClick={() => setDeleteModal({ open: true, selectedRole: row })}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Stack>
      ),
    },
  ];

  return (
    <>
      <Modal
        open={open}
        title={`سمت های ${selectedStaff?.full_name ?? ""}`}
        onClose={handleCloseModal}
        maxWidth="md"
      >
        <div className={classes.mainDiv}>
          <div className={classes.toolBar}>
            <Grid container rowSpacing={2} columnSpacing={1}>
              <Grid item xs={12} md={8} />
              <Grid item xs={12} md={4}>
                <div className={classes.manageBar}>
                  <Tooltip title="ایجاد سمت">
                    <IconButton
                      color="success"
                      onClick={() =>
                        setCreateUpdateModal({
                          open: true,
                          selectedRole: null,
                          selectedUser: selectedStaff?.id,
                        })
                      }
                    >
                      <AddCircleIcon />
                    </IconButton>
                  </Tooltip>
                </div>
              </Grid>
            </Grid>
          </div>

          <Table
            rows={rolesRows}
            columns={columns}
            hiddenPagination
            className={classes.tableContainer}
          />
        </div>
      </Modal>

      <CreateUpdateRoleModal
        open={createUpdateModal.open}
        onClose={handleCloseCreateUpdateModal}
        selectedUser={createUpdateModal.selectedUser}
        defaultData={createUpdateModal.selectedRole}
        reload={reload}
        setReload={setReload}
        onSuccess={handleCreateUpdateSuccess}
      />
      <ConfirmDeleteModal
        open={deleteModal.open}
        onClose={() => setDeleteModal({ open: false, selectedRole: null })}
        onConfirm={handleDeleteRole}
        loading={deleteLoading}
        title="حذف سمت کارمند"
        message="آیا از حذف سمت انتخاب‌شده برای این کارمند مطمئن هستید؟ دسترسی‌های مربوط به این سمت نیز حذف می‌شوند."
      />
    </>
  );
};
